import PropTypes from "prop-types"
import React, { useEffect } from "react"
import withRouter from "components/Common/withRouter"

// Layout Related Components
import Header from "./Header"
import Sidebar from "./Sidebar"
import Footer from "./Footer"

// No redux imports needed anymore for theme/right sidebar

const Layout = props => {
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)

  const toggleMenuCallback = () => {
    // Yeh function Sidebar toggle ke liye hai – agar tum isko use nahi kar rahe to isko bhi remove kar sakte ho
    // Abhi rakh raha hoon kyunki original code mein tha
    const sidebar = document.getElementById("sidebar-menu")
    if (sidebar) {
      if (document.body.classList.contains("sidebar-enable")) {
        document.body.classList.remove("sidebar-enable")
      } else {
        document.body.classList.add("sidebar-enable")
      }
    }
  }

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  // Yeh useEffect agar theme/layout change nahi kar rahe to optional hai
  useEffect(() => {
    // Agar vertical layout fixed rakhna hai to yeh line rakh sakte ho
    document.body.setAttribute("data-layout", "vertical")
  }, [])

  return (
    <React.Fragment>
      <div id="layout-wrapper">
        <Header toggleMenuCallback={toggleMenuCallback} />
        <Sidebar
          // theme aur type props ab optional hain – agar Sidebar component mein default hai to remove bhi kar sakte ho
          isMobile={isMobile}
        />
        <div className="main-content">{props.children}</div>
        <Footer />
      </div>
      {/* RightSidebar completely removed */}
    </React.Fragment>
  )
}

Layout.propTypes = {
  children: PropTypes.any,
  location: PropTypes.object,
}

export default withRouter(Layout)
